import { Navigate } from '@tanstack/react-router'
import { useTypedSelector } from 'hooks/useTypedSelector'

import { OnlyGuestProps } from './types'

export const OnlyGuest = ({ children }: OnlyGuestProps) => {
  const { token, inLoading } = useTypedSelector((state) => state.authReducer)

  if (token && !inLoading) {
    return <Navigate to="/" />
  }

  return children
}
